import { render, staticRenderFns } from "./CAP0550_co.vue?vue&type=template&id=da77b154&"
import script from "./CAP0550_co.vue?vue&type=script&lang=js&"
export * from "./CAP0550_co.vue?vue&type=script&lang=js&"
import style0 from "./CAP0550_co.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
